import React from 'react';

import { Box } from '@mui/material';

import AppLogo from '../AppLogo';
import EventsDropdown from './EventsDropdown';
import UserAvatarButton from '../UserAvatarButton';
import LogoutButton from '../LogoutButton';
import LanguageButton from '../LanguageButton';

import ROUTES from '../../constants/routes';

import { IAppHeader } from './interfaces';

import { useStyles } from './styles';
import { env } from '../../env';

const { REACT_APP_SHOW_PROFILE } = env;

const AppHeader = ({
  isAuthorized = false,
  showEventsDropdown = false,
}: IAppHeader) => {
  const classes = useStyles();
  const showProfile = REACT_APP_SHOW_PROFILE === 'true';

  return (
    <Box sx={classes.root}>
      <Box sx={classes.box}>
        <AppLogo to={isAuthorized ? ROUTES.SELECT_EVENT : ROUTES.LOGIN} />
      </Box>
      {showEventsDropdown && (
        <EventsDropdown
          sx={classes.eventsDropdown}
          menuProps={{ MenuListProps: { sx: classes.menuList } }}
        />
      )}
      {isAuthorized ? (
        <Box sx={classes.actionsContainer}>
          {showProfile ? <UserAvatarButton /> : null}
          <LogoutButton sx={classes.logoutButton} />
        </Box>
      ) : (
        <LanguageButton />
      )}
    </Box>
  );
};

export default AppHeader;
